import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../@types/RootState';

export type GetFamilyClusterModalPaginationState = {
  activePage: number;
  displayLength: number;
};

const initialState: GetFamilyClusterModalPaginationState = {
  activePage: 0,
  displayLength: 25,
};

const slice = createSlice({
  name: 'getFamilyClusterModal/pagination',
  initialState,
  reducers: {
    SET_GET_FAMILY_CLUSTER_MODAL_PAGINATION: (_state, { payload }: PayloadAction<GetFamilyClusterModalPaginationState>) => payload,
    UPDATE_GET_FAMILY_CLUSTER_MODAL_PAGINATION: (state, { payload }: PayloadAction<Partial<GetFamilyClusterModalPaginationState>>) => {
      return {
        ...state,
        ...payload,
      };
    },
    SET_GET_FAMILY_CLUSTER_MODAL_DISPLAY_LENGTH: (state, { payload }: PayloadAction<number>) => {
      return {
        ...state,
        displayLength: payload,
      };
    },
    SET_GET_FAMILY_CLUSTER_MODAL_ACTIVE_PAGE: (state, { payload }: PayloadAction<number>) => {
      return {
        ...state,
        activePage: payload,
      };
    },
  },
});

export const {
  SET_GET_FAMILY_CLUSTER_MODAL_PAGINATION,
  UPDATE_GET_FAMILY_CLUSTER_MODAL_PAGINATION,
  SET_GET_FAMILY_CLUSTER_MODAL_DISPLAY_LENGTH,
  SET_GET_FAMILY_CLUSTER_MODAL_ACTIVE_PAGE,
} = slice.actions;

export const selectorGetFamilyClusterModalPagination = (state: RootState) => {
  return state.getFamilyClusterModalReducer.pagination;
};

export default slice.reducer;
